import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = {
  key: 0,
  class: "marco"
}
const _hoisted_3 = { class: "encabezado-flex" }
const _hoisted_4 = { class: "acciones-encabezado" }
const _hoisted_5 = {
  key: 0,
  class: "panel-ocultar"
}
const _hoisted_6 = { class: "panel-titulo" }
const _hoisted_7 = { class: "panel-items" }
const _hoisted_8 = ["checked", "onChange"]
const _hoisted_9 = {
  key: 1,
  class: "sin-datos"
}
const _hoisted_10 = { class: "matriz-excel" }
const _hoisted_11 = { class: "matriz-leyenda" }
const _hoisted_12 = {
  key: 0,
  class: "matriz-tabla"
}
const _hoisted_13 = { class: "fila-header" }
const _hoisted_14 = { class: "cell col-comp-header" }
const _hoisted_15 = {
  key: 0,
  class: "fila-subtotal"
}
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { class: "cell subtotal-valor" }
const _hoisted_18 = ["rowspan"]
const _hoisted_19 = ["rowspan"]
const _hoisted_20 = ["rowspan"]
const _hoisted_21 = { class: "cell col-e" }
const _hoisted_22 = { class: "cell col-f" }
const _hoisted_23 = { class: "cell col-g" }
const _hoisted_24 = { class: "cell col-h" }
const _hoisted_25 = {
  key: 0,
  class: "valor-calculado"
}
const _hoisted_26 = {
  key: 0,
  class: "valor-calculado"
}
const _hoisted_27 = {
  key: 0,
  class: "valor-calculado"
}
const _hoisted_28 = { class: "cell col-n" }
const _hoisted_29 = {
  key: 0,
  class: "valor-calculado"
}
const _hoisted_30 = { class: "cell col-o" }
const _hoisted_31 = { class: "cell col-p" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "fila-total" }
const _hoisted_34 = ["colspan"]
const _hoisted_35 = { class: "cell col-k" }
const _hoisted_36 = { class: "cell col-l" }
const _hoisted_37 = { class: "cell col-m" }
const _hoisted_38 = { class: "cell col-n total-valor" }
const _hoisted_39 = {
  key: 1,
  class: "matriz-tabla"
}
const _hoisted_40 = { class: "fila-header" }
const _hoisted_41 = { class: "cell col-comp-header" }
const _hoisted_42 = {
  key: 0,
  class: "fila-subtotal"
}
const _hoisted_43 = ["colspan"]
const _hoisted_44 = { class: "cell subtotal-valor" }
const _hoisted_45 = ["rowspan"]
const _hoisted_46 = ["rowspan"]
const _hoisted_47 = ["rowspan"]
const _hoisted_48 = { class: "cell col-n" }
const _hoisted_49 = {
  key: 0,
  class: "valor-calculado"
}
const _hoisted_50 = { class: "cell col-o" }
const _hoisted_51 = { class: "cell col-p" }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "fila-total" }
const _hoisted_54 = ["colspan"]
const _hoisted_55 = { class: "cell col-n total-valor" }

import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useComponentes } from '@/store/GestionComponentes'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useModelo } from '@/store/GestionModelo'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { getEvaluacionesIndicadorService } from '@/services/EvaluacionIndicadorService'
import { getProcesosService } from '@/services/ProcesoAutoevaluacionService'
import type Componente from '@/interfaces/Componente'
import type Indicador from '@/interfaces/Indicador'
import type Instrumento from '@/interfaces/Instrumetos'
import type IndicadorInstrumento from '@/interfaces/IndicadorInstrumento'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeToast from '@/components/MensajeToast.vue'
import { limpiarNiveles } from '@/utils/nivelesHelper'
import { podarArbolInactivo } from '@/utils/estructuraActiva'

/* ─── Tipos internos ─── */
interface FilaMatriz {
  tipo: 'componente' | 'indicador' | 'instrumento'
  idComponente: number | null
  numComponente: string
  nombreComponente: string
  rutaNumeros: string[]
  rutaComponentes: string[]
  rutaPesos: string[]
  pesoComponente: string
  nivelComponente: number
  idIndicador: number | null
  numIndicador: string
  nombreIndicador: string
  pesoIndicador: string
  idInstrumento: number | null
  idTipoComponente: number | null
  nombreInstrumento: string
  tipoInstrumento: string
  tipoFuente: 'documental' | 'cuantitativa' | 'opinion' | null
  calDocumental: number | null
  calCuantitativa: number | null
  calOpinion: number | null
  calPonderada: number | null
  evaluacionId: number | null
  grado: string | null
  clasificacion: 'fuerte' | 'debil' | 'muy_debil' | 'no_aplica'
}

interface FilaSubtotal {
  tipo: 'subtotal'
  nombrePrimerNivel: string
  calPonderada: number | null
}

// Por cada nivel de componente, cuántas filas ocupa (rowspan) y si debe renderizarse en esta fila
interface SpanInfo {
  render: boolean   // false = esta celda está "fusionada" con la superior, no renderizar
  span: number      // cuántas filas abarca (para rowspan)
}

type FilaRenderizada =
  | { tipo: 'data'; fila: FilaMatriz; spansNivel: SpanInfo[] }
  | { tipo: 'subtotal'; sub: FilaSubtotal }

/* ─── State ─── */

export default /*@__PURE__*/_defineComponent({
  __name: 'EvaluacionExpertosView',
  setup(__props) {

/**
 * Evaluación por pares externos.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/version/:id_version/evaluacion-expertos` (EvaluacionExpertos) — permiso `expertos.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const router = useRouter()
const storeComponentes = useComponentes()
const storeIndicadores = useGestionIndicadores()
const storeRelaciones = useGestionIndicadorInstrumentos()
const storeInstrumentos = useGestionInstrumento()
const storeTiposComponente = useGestionTipoComponente()
const storeVersiones = useGestionVersiones()
const storeModelos = useModelo()
const toastRef = ref<InstanceType<typeof MensajeToast> | null>(null)

const idVersion = Number(route.params.id_version)
const loading = ref(true)
const filas = ref<FilaMatriz[]>([])
const esModeloHistorico = ref(false)
const nombresNivelesModelo = ref<string[]>([])
const escalaMax = ref<number>(5)
const mostrarPanel = ref(false)
const ocultos = ref<Set<string>>(new Set())

const nombresNivelesComponentes = computed(() => {
  const normalizados = nombresNivelesModelo.value
    .map(nombre => nombre.trim())
    .filter(nombre => nombre.length > 0)

  const cantidadColumnas = Math.max(
    normalizados.length,
    ...filas.value.map(fila => fila.rutaComponentes.length),
    1
  )

  return Array.from({ length: cantidadColumnas }, (_, index) => {
    return normalizados[index] ?? `Nivel ${index + 1}`
  })
})

const filasRenderizadas = computed<FilaRenderizada[]>(() => {
  const filasBase = filas.value.filter(f => {
    const k = f.rutaNumeros[0]
    return !k || !ocultos.value.has(k)
  })
  const numNiveles = nombresNivelesComponentes.value.length

  // Primero armar lista con subtotales intercalados (referencias directas a FilaMatriz)
  type EntradaConSub = { tipo: 'data'; fila: FilaMatriz } | { tipo: 'subtotal'; sub: FilaSubtotal }
  const conSubtotales: EntradaConSub[] = []

  for (let index = 0; index < filasBase.length; index++) {
    const filaActual = filasBase[index]
    conSubtotales.push({ tipo: 'data', fila: filaActual })

    const primerNivelActual = filaActual.rutaNumeros[0] ?? ''
    const siguienteFila = filasBase[index + 1]
    const primerNivelSiguiente = siguienteFila?.rutaNumeros[0] ?? ''

    if (primerNivelActual && primerNivelActual !== primerNivelSiguiente) {
      conSubtotales.push({
        tipo: 'subtotal',
        sub: {
          tipo: 'subtotal',
          nombrePrimerNivel: filaActual.rutaComponentes[0] ?? primerNivelActual,
          calPonderada: subtotalPorPrimerNivel.value[primerNivelActual]?.ponderada ?? null
        }
      })
    }
  }

  // Calcular spans para columnas de componente, preservando la referencia directa a cada fila
  const resultado: FilaRenderizada[] = []
  const spansAux: Array<SpanInfo[] | null> = [] 

  for (let i = 0; i < conSubtotales.length; i++) {
    const entrada = conSubtotales[i]

    if (entrada.tipo === 'subtotal') {
      resultado.push({ tipo: 'subtotal', sub: entrada.sub })
      spansAux.push(null)
      continue
    }

    const fila = entrada.fila
    const spansNivel: SpanInfo[] = []

    for (let nivel = 0; nivel < numNiveles; nivel++) {
      const valorActual = fila.rutaNumeros[nivel] ?? ''

      if (!valorActual) {
        spansNivel.push({ render: false, span: 0 })
        continue
      }

      // Buscar hacia atrás si ya existe un dueño del span para este valor/nivel
      let yaAbarcada = false
      for (let k = resultado.length - 1; k >= 0; k--) {
        const prevSpans = spansAux[k]
        if (prevSpans === null) break // subtotal rompe el span
        const prevFila = (conSubtotales[k] as { tipo: 'data'; fila: FilaMatriz }).fila
        const prevVal = prevFila.rutaNumeros[nivel] ?? ''
        if (prevVal !== valorActual) break
        if (prevSpans[nivel]?.render) { yaAbarcada = true; break }
        // prevSpans[nivel].render=false → sigue mirando atrás
      }

      if (yaAbarcada) {
        spansNivel.push({ render: false, span: 0 })
        continue
      }

      // Contar filas consecutivas hacia adelante con el mismo valor en este nivel
      let span = 1
      for (let j = i + 1; j < conSubtotales.length; j++) {
        const sig = conSubtotales[j]
        if (sig.tipo === 'subtotal') break
        if (sig.fila.rutaNumeros[nivel] === valorActual) span++
        else break
      }

      spansNivel.push({ render: true, span })
    }

    resultado.push({ tipo: 'data', fila, spansNivel })
    spansAux.push(spansNivel)
  }

  return resultado
})

/* ─── Helpers ─── */
function formatNum(val: number | null | undefined): string {
  if (val == null || isNaN(val)) return ''
  return new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(val)
}

function showToast(msg: string, tipo: 'exito' | 'error' = 'exito') {
  toastRef.value?.showToast(msg, tipo)
}

function normalizarTexto(valor: string | null | undefined): string {
  return (valor ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

function resolverClasificacionPorNota(cal: number | null, escala: number): 'fuerte' | 'debil' | 'muy_debil' | 'no_aplica' {
  if (cal == null) return 'no_aplica'
  const pct = cal / escala
  if (pct >= 0.75) return 'fuerte'
  if (pct >= 0.50) return 'debil'
  return 'muy_debil'
}

const primerNivelItems = computed(() => {
  const seen = new Set<string>()
  const items: { key: string; nombre: string }[] = []
  for (const fila of filas.value) {
    const key = fila.rutaNumeros[0]
    if (key && !seen.has(key)) {
      seen.add(key)
      items.push({ key, nombre: fila.rutaComponentes[0] ?? key })
    }
  }
  return items
})

function estaOculto(key: string): boolean {
  return ocultos.value.has(key)
}

function toggleOculto(key: string): void {
  const s = new Set(ocultos.value)
  s.has(key) ? s.delete(key) : s.add(key)
  ocultos.value = s
}

function clasifLabel(c: string): string {
  return ({ fuerte: 'Fuerte', debil: 'Débil', muy_debil: 'Muy débil', no_aplica: 'No aplica' } as Record<string, string>)[c] ?? '—'
}

function resolverTipoFuente(idTipoComponente: number | null, tipoInstrumento: string): 'documental' | 'cuantitativa' | 'opinion' | null {
  const tipo = idTipoComponente != null
    ? storeTiposComponente.tipos.find(item => item.id_tipo_componente === idTipoComponente)?.nombre
    : null

  const texto = normalizarTexto(tipo || tipoInstrumento)

  if (texto.includes('documental') || texto.includes('documento')) return 'documental'
  if (texto.includes('cuantitativ') || texto.includes('estadistic')) return 'cuantitativa'
  if (texto.includes('opinion') || texto.includes('encuesta')) return 'opinion'
  return null
}

function esTipoFuente(fila: FilaMatriz, tipo: 'documental' | 'cuantitativa' | 'opinion'): boolean {
  return fila.tipoFuente === tipo
}

function claseCeldaFuente(fila: FilaMatriz, tipo: 'documental' | 'cuantitativa' | 'opinion'): string {
  if (!esTipoFuente(fila, tipo)) return 'fuente-inactiva'
  if (tipo === 'documental') return 'fuente-activa-doc'
  if (tipo === 'cuantitativa') return 'fuente-activa-cuant'
  return 'fuente-activa-opin'
}

const subtotalPorPrimerNivel = computed(() => {
  const acumulado: Record<string, { ponderada: number | null }> = {}

  const filasAgrupables = filas.value.filter(fila => {
    if (!fila.rutaNumeros[0]) return false
    if (esModeloHistorico.value) return fila.tipo === 'componente' && fila.calPonderada != null
    if (fila.tipo === 'instrumento') return fila.calPonderada != null
    if (fila.tipo === 'indicador') return fila.calPonderada != null
    return false
  })

  for (const fila of filasAgrupables) {
    const clave = fila.rutaNumeros[0]
    if (!acumulado[clave]) {
      acumulado[clave] = { ponderada: null }
    }
  }

  const claves = [...new Set(filasAgrupables.map(fila => fila.rutaNumeros[0]))]
  for (const clave of claves) {
    const filasDelGrupo = filasAgrupables.filter(fila => fila.rutaNumeros[0] === clave)
    const ponderadas = filasDelGrupo
      .map(fila => fila.calPonderada)
      .filter((valor): valor is number => valor != null && !isNaN(valor))

    acumulado[clave] = {
      ponderada: ponderadas.length
        ? ponderadas.reduce((suma, valor) => suma + valor, 0) / ponderadas.length
        : null
    }
  }

  return acumulado
})

function claseFilaTipo(tipo: string): string {
  if (tipo === 'componente') return 'fila-componente'
  if (tipo === 'indicador') return 'fila-indicador'
  return 'fila-instrumento'
}

function volver() {
  router.back()
}

/* ─── Arrastre de la tabla ─── */
const matrizWrap = ref<HTMLElement | null>(null)
let arrastrando = false
let arrastreX = 0
let arrastreY = 0
let scrollIniX = 0
let scrollIniY = 0

function iniciarArrastre(e: MouseEvent): void {
  const el = matrizWrap.value
  if (!el) return
  arrastrando = true
  arrastreX = e.clientX
  arrastreY = e.clientY
  scrollIniX = el.scrollLeft
  scrollIniY = el.scrollTop
  el.style.cursor = 'grabbing'
  el.style.userSelect = 'none'
}

function moverArrastre(e: MouseEvent): void {
  if (!arrastrando || !matrizWrap.value) return
  e.preventDefault()
  matrizWrap.value.scrollLeft = scrollIniX - (e.clientX - arrastreX)
  matrizWrap.value.scrollTop  = scrollIniY - (e.clientY - arrastreY)
}

function detenerArrastre(): void {
  arrastrando = false
  if (matrizWrap.value) {
    matrizWrap.value.style.cursor = 'grab'
    matrizWrap.value.style.userSelect = ''
  }
}

/* ─── Carga de datos ─── */
onMounted(async () => {
  try {
    loading.value = true

    if (!Number.isFinite(idVersion) || idVersion <= 0) {
      showToast('ID de versión inválido', 'error')
      return
    }

    await storeTiposComponente.getTipos()

    const version = await storeVersiones.getVersionById(idVersion)
    const idModelo = version?.id_modelo ?? null
    if (idModelo) {
      const modelo = await storeModelos.getModeloById(idModelo)
      nombresNivelesModelo.value = limpiarNiveles(modelo?.niveles)
      escalaMax.value = modelo?.escala_max ?? 5
    }

    const raiz = idModelo ? await storeComponentes.cargarRaizPorModelo(idModelo) : null
    if (!raiz?.id_componente) {
      showToast('No se encontró componente raíz para este modelo', 'error')
      return
    }
    await storeComponentes.cargarArbolDesdeRaiz(raiz.id_componente)

    await Promise.all([
      storeRelaciones.getRelaciones(),
      storeIndicadores.cargarTodos(),
      storeInstrumentos.cargarTodos()
    ])

    // Detectar si es modelo histórico (sin instrumentos vinculados)
    const indicadoresVersion = storeIndicadores.indicadores.filter(i => i.id_version === idVersion)
    const idsInd = new Set(indicadoresVersion.map(i => i.id_indicador).filter((id): id is number => id != null))
    esModeloHistorico.value = idsInd.size > 0 && !storeRelaciones.relaciones.some(r => idsInd.has(r.id_indicador))

    const todasEvaluaciones = await getEvaluacionesIndicadorService({ id_version: idVersion })
    const procesos = await getProcesosService({ id_version: idVersion })
    const proceso = procesos.find(p => p.estado !== 'finalizado') ?? procesos[procesos.length - 1] ?? null
    const idEjecucion = proceso?.id ?? null
    const evaluacionesExistentes = idEjecucion != null
      ? todasEvaluaciones.filter(e => e.id_ejecucion === idEjecucion)
      : todasEvaluaciones
    // Oculta aspectos/componentes sin indicador en esta versión (estructura compartida).
    const activos = await storeVersiones.getIdsComponentesActivos(idVersion)
    construirMatriz(podarArbolInactivo(storeComponentes.componentes, activos), evaluacionesExistentes, esModeloHistorico.value)

    recalcular()
  } catch (err) {
    console.error('Error al cargar evaluación:', err)
    showToast('Error al cargar los datos', 'error')
  } finally {
    loading.value = false
  }
})

/* ─── Construir matriz ─── */
function construirMatriz(
  arbol: Componente[],
  evaluaciones: any[],
  historicoModelo = false
) {
  const resultado: FilaMatriz[] = []

  function recorrer(
    componentes: Componente[],
    nivel: number,
    contadorComp: number[],
    rutaNumerosPadre: string[],
    rutaPesosPadre: string[],
    rutaPadre: string[]
  ) {
    const componentesOrdenados = [...componentes].sort((a, b) => {
      const ordA = a.ordinal ?? ''
      const ordB = b.ordinal ?? ''
      return ordA.localeCompare(ordB, undefined, { numeric: true, sensitivity: 'base' })
    })
    for (let i = 0; i < componentesOrdenados.length; i++) {
      const comp = componentesOrdenados[i]
      const numComp = [...contadorComp, i + 1].join('.')
      const esHoja = !comp.children?.length
      const rutaNumerosActual = [...rutaNumerosPadre, numComp]
      const rutaActual = [...rutaPadre, comp.nombre]
      const rutaPesosActual = [...rutaPesosPadre, comp.peso != null ? String(comp.peso) : '']

      // Obtener indicadores del componente hoja
      let indicadores: Indicador[] = []
      if (esHoja && comp.id_componente) {
        indicadores = storeIndicadores.indicadores.filter(
          i => i.id_componente === comp.id_componente && i.id_version === idVersion
        )
      }

      if (esHoja && indicadores.length > 0) {
        const esHistoricoIndicador = indicadores.every(
          ind => normalizarTexto(ind.nombre ?? ind.enunciado) === normalizarTexto(comp.nombre)
        )

        if (historicoModelo || esHistoricoIndicador) {
          const evalsHistorico = indicadores
            .map(ind => evaluaciones.find(e => e.id_indicador === ind.id_indicador))
            .filter(Boolean)
          const vals = evalsHistorico
            .map(e => e?.calificacion_final)
            .filter((v): v is number => v != null)
          resultado.push({
            tipo: 'componente',
            idComponente: comp.id_componente ?? null,
            numComponente: numComp,
            nombreComponente: comp.nombre,
            rutaNumeros: rutaNumerosActual,
            rutaComponentes: rutaActual,
            rutaPesos: rutaPesosActual,
            pesoComponente: comp.peso != null ? String(comp.peso) : '',
            nivelComponente: nivel,
            idIndicador: indicadores[0]?.id_indicador ?? null,
            numIndicador: '',
            nombreIndicador: '',
            pesoIndicador: '',
            idInstrumento: null,
            idTipoComponente: null,
            nombreInstrumento: '',
            tipoInstrumento: '',
            tipoFuente: null,
            calDocumental: evalsHistorico[0]?.calificacion_documental ?? null,
            calCuantitativa: evalsHistorico[0]?.calificacion_cuantitativa ?? null,
            calOpinion: evalsHistorico[0]?.calificacion_opinion ?? null,
            calPonderada: vals.length ? vals.reduce((s, v) => s + v, 0) / vals.length : null,
            evaluacionId: evalsHistorico[0]?.id ?? null,
            grado: evalsHistorico[0]?.nivel_asignado ?? null,
            clasificacion: resolverClasificacionPorNota(vals.length ? vals.reduce((s, v) => s + v, 0) / vals.length : null, escalaMax.value)
          })
        } else {

        for (let j = 0; j < indicadores.length; j++) {
          const ind = indicadores[j]
          // Buscar instrumentos vinculados a este indicador
          const relaciones = storeRelaciones.relaciones.filter(
            (r: IndicadorInstrumento) => r.id_indicador === ind.id_indicador
          )

          const instrumentos = relaciones
            .map(rel => storeInstrumentos.instrumentos.find(i => i.id_instrumento === rel.id_instrumento))
            .filter((i): i is Instrumento => i != null)

          // Buscar evaluación existente
          const evalExistente = evaluaciones.find(
            e => e.id_indicador === ind.id_indicador
          )

          if (instrumentos.length > 0) {
            for (const inst of instrumentos) {
              resultado.push({
                tipo: 'instrumento',
                idComponente: comp.id_componente ?? null,
                numComponente: numComp,
                nombreComponente: comp.nombre,
                rutaNumeros: rutaNumerosActual,
                rutaComponentes: rutaActual,
                rutaPesos: rutaPesosActual,
                pesoComponente: comp.peso != null ? String(comp.peso) : '',
                nivelComponente: nivel,
                idIndicador: ind.id_indicador,
                numIndicador: String(j + 1),
                nombreIndicador: ind.nombre ?? ind.enunciado,
                pesoIndicador: ind.peso_snapshot != null ? String(ind.peso_snapshot) : '',
                idInstrumento: inst.id_instrumento ?? null,
                idTipoComponente: inst.id_tipo_componente ?? ind.id_tipo_componente ?? null,
                nombreInstrumento: inst.herramienta,
                tipoInstrumento: inst.descripcion ?? '',
                tipoFuente: resolverTipoFuente(inst.id_tipo_componente ?? ind.id_tipo_componente ?? null, inst.descripcion ?? ''),
                calDocumental: evalExistente?.calificacion_documental ?? null,
                calCuantitativa: evalExistente?.calificacion_cuantitativa ?? null,
                calOpinion: evalExistente?.calificacion_opinion ?? null,
                calPonderada: evalExistente?.calificacion_final ?? null,
                evaluacionId: evalExistente?.id ?? null,
                grado: evalExistente?.nivel_asignado ?? null,
                clasificacion: resolverClasificacionPorNota(evalExistente?.calificacion_final ?? null, escalaMax.value)
              })
            }
          } else {
            // Indicador sin instrumentos: fila de indicador solo
            resultado.push({
              tipo: 'indicador',
              idComponente: comp.id_componente ?? null,
              numComponente: numComp,
              nombreComponente: comp.nombre,
              rutaNumeros: rutaNumerosActual,
              rutaComponentes: rutaActual,
              rutaPesos: rutaPesosActual,
              pesoComponente: comp.peso != null ? String(comp.peso) : '',
              nivelComponente: nivel,
              idIndicador: ind.id_indicador,
              numIndicador: String(j + 1),
              nombreIndicador: ind.nombre ?? ind.enunciado,
              pesoIndicador: ind.peso_snapshot != null ? String(ind.peso_snapshot) : '',
              idInstrumento: null,
              idTipoComponente: ind.id_tipo_componente ?? null,
              nombreInstrumento: '',
              tipoInstrumento: '',
              tipoFuente: resolverTipoFuente(ind.id_tipo_componente ?? null, ''),
              calDocumental: evalExistente?.calificacion_documental ?? null,
              calCuantitativa: evalExistente?.calificacion_cuantitativa ?? null,
              calOpinion: evalExistente?.calificacion_opinion ?? null,
              calPonderada: evalExistente?.calificacion_final ?? null,
              evaluacionId: evalExistente?.id ?? null,
              grado: evalExistente?.nivel_asignado ?? null,
              clasificacion: resolverClasificacionPorNota(evalExistente?.calificacion_final ?? null, escalaMax.value)
            })
          }
        }
        } // end else (no histórico)
      } else if (!esHoja) {
        // Los componentes padre solo estructuran la ruta; no se muestran como filas independientes.
        if (comp.children?.length) {
          recorrer(comp.children, nivel + 1, [...contadorComp, i + 1], rutaNumerosActual, rutaPesosActual, rutaActual)
        }
      } else {
        resultado.push({
          tipo: 'componente',
          idComponente: comp.id_componente ?? null,
          numComponente: numComp,
          nombreComponente: comp.nombre,
          rutaNumeros: rutaNumerosActual,
          rutaComponentes: rutaActual,
          rutaPesos: rutaPesosActual,
          pesoComponente: comp.peso != null ? String(comp.peso) : '',
          nivelComponente: nivel,
          idIndicador: null,
          numIndicador: '',
          nombreIndicador: '',
          pesoIndicador: '',
          idInstrumento: null,
          idTipoComponente: null,
          nombreInstrumento: '',
          tipoInstrumento: '',
          tipoFuente: null,
          calDocumental: null,
          calCuantitativa: null,
          calOpinion: null,
          calPonderada: null,
          evaluacionId: null,
          grado: null,
          clasificacion: 'no_aplica' as const
        })
      }
    }
  }

  // Empezar desde los hijos de la raíz (la raíz es invisible)
  const raiz = arbol[0]
  if (raiz?.children?.length) {
    recorrer(raiz.children, 0, [], [], [], [])
  }

  filas.value = resultado
}

/* ─── Recalcular ponderaciones (instrumentos → indicadores → componentes) ─── */
function recalcular() {
  const rows = filas.value

  // 1. Calcular ponderada de cada instrumento
  for (const fila of rows) {
    if (fila.tipo === 'instrumento') {
      const d = fila.calDocumental
      const c = fila.calCuantitativa
      const o = fila.calOpinion

      const partes = [
        { val: d, peso: 0.30 },
        { val: c, peso: 0.35 },
        { val: o, peso: 0.35 }
      ].filter(p => p.val != null && !isNaN(p.val!))

      if (partes.length > 0) {
        const totalPeso = partes.reduce((s, p) => s + p.peso, 0)
        const totalVal = partes.reduce((s, p) => s + (p.val! * p.peso), 0)
        fila.calPonderada = totalVal / totalPeso
      } else {
        fila.calPonderada = null
      }
      fila.clasificacion = resolverClasificacionPorNota(fila.calPonderada, escalaMax.value)
    }
  }

  // 2. Agrupar instrumentos por indicador y calcular promedio → indicador
  const indicadorIds = [...new Set(
    rows.filter(r => r.tipo === 'instrumento' && r.idIndicador != null).map(r => r.idIndicador!)
  )]

  const promedioIndicador: Record<number, { doc: number | null; cuant: number | null; opin: number | null; pond: number | null }> = {}

  for (const idInd of indicadorIds) {
    const instrumentos = rows.filter(r => r.tipo === 'instrumento' && r.idIndicador === idInd)
    const conDoc = instrumentos.filter(r => r.calDocumental != null)
    const conCuant = instrumentos.filter(r => r.calCuantitativa != null)
    const conOpin = instrumentos.filter(r => r.calOpinion != null)
    const conPond = instrumentos.filter(r => r.calPonderada != null)

    promedioIndicador[idInd] = {
      doc: conDoc.length ? conDoc.reduce((s, r) => s + r.calDocumental!, 0) / conDoc.length : null,
      cuant: conCuant.length ? conCuant.reduce((s, r) => s + r.calCuantitativa!, 0) / conCuant.length : null,
      opin: conOpin.length ? conOpin.reduce((s, r) => s + r.calOpinion!, 0) / conOpin.length : null,
      pond: conPond.length ? conPond.reduce((s, r) => s + r.calPonderada!, 0) / conPond.length : null
    }
  }

  // 3. Agrupar indicadores por componente y calcular promedio ponderado → componente
  const componenteIds = [...new Set(
    rows.filter(r => r.tipo === 'componente' && r.idComponente != null).map(r => r.idComponente!)
  )]

  for (const idComp of componenteIds) {
    // Buscar todos los indicadores que pertenecen a los hijos de este componente
    const indicadoresDeComp = rows.filter(
      r => (r.tipo === 'instrumento' || r.tipo === 'indicador') && r.idComponente === idComp
    )

    const idsIndUnicos = [...new Set(indicadoresDeComp.filter(r => r.idIndicador != null).map(r => r.idIndicador!))]

    if (idsIndUnicos.length === 0) continue

    let sumaDoc = 0, countDoc = 0
    let sumaCuant = 0, countCuant = 0
    let sumaOpin = 0, countOpin = 0
    let sumaPond = 0, countPond = 0

    for (const idInd of idsIndUnicos) {
      const prom = promedioIndicador[idInd]
      if (prom) {
        if (prom.doc != null) { sumaDoc += prom.doc; countDoc++ }
        if (prom.cuant != null) { sumaCuant += prom.cuant; countCuant++ }
        if (prom.opin != null) { sumaOpin += prom.opin; countOpin++ }
        if (prom.pond != null) { sumaPond += prom.pond; countPond++ }
      }
    }

    // Actualizar la fila del componente
    const filaComp = rows.find(r => r.tipo === 'componente' && r.idComponente === idComp)
    if (filaComp) {
      filaComp.calDocumental = countDoc > 0 ? sumaDoc / countDoc : null
      filaComp.calCuantitativa = countCuant > 0 ? sumaCuant / countCuant : null
      filaComp.calOpinion = countOpin > 0 ? sumaOpin / countOpin : null
      filaComp.calPonderada = countPond > 0 ? sumaPond / countPond : null
      filaComp.clasificacion = resolverClasificacionPorNota(filaComp.calPonderada, escalaMax.value)
    }
  }
}

/* ─── Totales generales ─── */
const totalesGenerales = computed(() => {
  if (esModeloHistorico.value) {
    const comps = filas.value.filter(r => r.tipo === 'componente')
    const conPond = comps.filter(r => r.calPonderada != null)
    return {
      documental: null,
      cuantitativa: null,
      opinion: null,
      ponderada: conPond.length ? conPond.reduce((s, r) => s + r.calPonderada!, 0) / conPond.length : null
    }
  }

  const comps = filas.value.filter(r => r.tipo === 'componente' && r.nivelComponente === 0)

  if (!comps.length) {
    // Si no hay componentes de nivel 0, usar todos los instrumentos
    const instrumentos = filas.value.filter(r => r.tipo === 'instrumento')
    const conPond = instrumentos.filter(r => r.calPonderada != null)
    const conDoc = instrumentos.filter(r => r.calDocumental != null)
    const conCuant = instrumentos.filter(r => r.calCuantitativa != null)
    const conOpin = instrumentos.filter(r => r.calOpinion != null)

    return {
      documental: conDoc.length ? conDoc.reduce((s, r) => s + r.calDocumental!, 0) / conDoc.length : null,
      cuantitativa: conCuant.length ? conCuant.reduce((s, r) => s + r.calCuantitativa!, 0) / conCuant.length : null,
      opinion: conOpin.length ? conOpin.reduce((s, r) => s + r.calOpinion!, 0) / conOpin.length : null,
      ponderada: conPond.length ? conPond.reduce((s, r) => s + r.calPonderada!, 0) / conPond.length : null
    }
  }

  const conDoc = comps.filter(r => r.calDocumental != null)
  const conCuant = comps.filter(r => r.calCuantitativa != null)
  const conOpin = comps.filter(r => r.calOpinion != null)
  const conPond = comps.filter(r => r.calPonderada != null)

  return {
    documental: conDoc.length ? conDoc.reduce((s, r) => s + r.calDocumental!, 0) / conDoc.length : null,
    cuantitativa: conCuant.length ? conCuant.reduce((s, r) => s + r.calCuantitativa!, 0) / conCuant.length : null,
    opinion: conOpin.length ? conOpin.reduce((s, r) => s + r.calOpinion!, 0) / conOpin.length : null,
    ponderada: conPond.length ? conPond.reduce((s, r) => s + r.calPonderada!, 0) / conPond.length : null
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: loading.value,
      message: "Cargando evaluación..."
    }, null, 8, ["visible"]),
    _createVNode(MensajeToast, {
      ref_key: "toastRef",
      ref: toastRef
    }, null, 512),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Evaluación por Expertos", -1)),
            _createElementVNode("div", _hoisted_4, [
              (filas.value.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn toggle-panel",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (mostrarPanel.value = !mostrarPanel.value))
                  }, _toDisplayString(mostrarPanel.value ? 'Cerrar' : 'Mostrar / ocultar'), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn salir",
                onClick: volver
              }, "Volver")
            ])
          ]),
          _cache[50] || (_cache[50] = _createElementVNode("div", { class: "divisor" }, null, -1)),
          (mostrarPanel.value && primerNivelItems.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, "Mostrar u ocultar " + _toDisplayString(nombresNivelesComponentes.value[0] ?? 'Nivel 1'), 1),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(primerNivelItems.value, (item) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: item.key,
                      class: "chk"
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: !estaOculto(item.key),
                        onChange: ($event: any) => (toggleOculto(item.key))
                      }, null, 40, _hoisted_8),
                      _createTextVNode(" " + _toDisplayString(item.key) + ". " + _toDisplayString(item.nombre), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (!filas.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " No se encontraron componentes, indicadores o instrumentos para esta versión. "))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                ref_key: "matrizWrap",
                ref: matrizWrap,
                class: "matriz-wrap",
                onMousedown: iniciarArrastre,
                onMousemove: moverArrastre,
                onMouseup: detenerArrastre,
                onMouseleave: detenerArrastre
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "matriz-titulo" }, " MATRIZ DE CALIFICACIÓN POR EXPERTOS ", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    (esModeloHistorico.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" Modelo histórico · Calificaciones provenientes de la nota final registrada en la evaluación de cada componente. ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Celdas amarillas = Documental (30%) · Celdas verdes = Cuantitativo (35%) · Celdas azules = Opinión (35%). Los valores provienen de la evaluación de indicadores. Los totales se calculan automáticamente. ")
                        ], 64))
                  ]),
                  (!esModeloHistorico.value)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                        _createElementVNode("colgroup", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nombresNivelesComponentes.value, (_, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `col-group-${index}`
                            }, [
                              _cache[2] || (_cache[2] = _createElementVNode("col", { class: "col-comp-num-col" }, null, -1)),
                              _cache[3] || (_cache[3] = _createElementVNode("col", { class: "col-comp-col" }, null, -1)),
                              _cache[4] || (_cache[4] = _createElementVNode("col", { class: "col-comp-peso-col" }, null, -1))
                            ], 64))
                          }), 128)),
                          _cache[5] || (_cache[5] = _createElementVNode("col", { class: "col-e-col" }, null, -1)),
                          _cache[6] || (_cache[6] = _createElementVNode("col", { class: "col-f-col" }, null, -1)),
                          _cache[7] || (_cache[7] = _createElementVNode("col", { class: "col-g-col" }, null, -1)),
                          _cache[8] || (_cache[8] = _createElementVNode("col", { class: "col-h-col" }, null, -1)),
                          _cache[9] || (_cache[9] = _createElementVNode("col", { class: "col-k-col" }, null, -1)),
                          _cache[10] || (_cache[10] = _createElementVNode("col", { class: "col-l-col" }, null, -1)),
                          _cache[11] || (_cache[11] = _createElementVNode("col", { class: "col-m-col" }, null, -1)),
                          _cache[12] || (_cache[12] = _createElementVNode("col", { class: "col-n-col" }, null, -1)),
                          _cache[13] || (_cache[13] = _createElementVNode("col", { class: "col-o-col" }, null, -1)),
                          _cache[14] || (_cache[14] = _createElementVNode("col", { class: "col-p-col" }, null, -1))
                        ]),
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nombresNivelesComponentes.value, (nombreNivel, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: `nivel-header-${index}`
                              }, [
                                _cache[15] || (_cache[15] = _createElementVNode("th", { class: "cell col-comp-num" }, "N°", -1)),
                                _createElementVNode("th", _hoisted_14, _toDisplayString(nombreNivel), 1),
                                _cache[16] || (_cache[16] = _createElementVNode("th", { class: "cell col-comp-peso" }, "PESO", -1))
                              ], 64))
                            }), 128)),
                            _cache[17] || (_cache[17] = _createElementVNode("th", { class: "cell col-e" }, "INDICADOR", -1)),
                            _cache[18] || (_cache[18] = _createElementVNode("th", { class: "cell col-f" }, "PESO", -1)),
                            _cache[19] || (_cache[19] = _createElementVNode("th", { class: "cell col-g" }, "INSTRUMENTO / FUENTE", -1)),
                            _cache[20] || (_cache[20] = _createElementVNode("th", { class: "cell col-h" }, "TIPO", -1)),
                            _cache[21] || (_cache[21] = _createElementVNode("th", { class: "cell col-k fuente-doc" }, [
                              _createTextVNode("CAL."),
                              _createElementVNode("br"),
                              _createTextVNode("DOCUMENTAL"),
                              _createElementVNode("br"),
                              _createTextVNode("(30%)")
                            ], -1)),
                            _cache[22] || (_cache[22] = _createElementVNode("th", { class: "cell col-l fuente-cuant" }, [
                              _createTextVNode("CAL."),
                              _createElementVNode("br"),
                              _createTextVNode("CUANTITATIVA"),
                              _createElementVNode("br"),
                              _createTextVNode("(35%)")
                            ], -1)),
                            _cache[23] || (_cache[23] = _createElementVNode("th", { class: "cell col-m fuente-opin" }, [
                              _createTextVNode("CAL."),
                              _createElementVNode("br"),
                              _createTextVNode("OPINIÓN"),
                              _createElementVNode("br"),
                              _createTextVNode("(35%)")
                            ], -1)),
                            _cache[24] || (_cache[24] = _createElementVNode("th", { class: "cell col-n" }, [
                              _createTextVNode("CAL."),
                              _createElementVNode("br"),
                              _createTextVNode("PONDERADA")
                            ], -1)),
                            _cache[25] || (_cache[25] = _createElementVNode("th", { class: "cell col-o" }, [
                              _createTextVNode("NIVEL DE"),
                              _createElementVNode("br"),
                              _createTextVNode("CUMPLIMIENTO")
                            ], -1)),
                            _cache[26] || (_cache[26] = _createElementVNode("th", { class: "cell col-p" }, "FORTALEZA", -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasRenderizadas.value, (item, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `row-${idx}`
                            }, [
                              (item.tipo === 'subtotal')
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                                    _createElementVNode("td", {
                                      class: "cell subtotal-label",
                                      colspan: nombresNivelesComponentes.value.length * 3 + 4
                                    }, " Subtotal de " + _toDisplayString(nombresNivelesComponentes.value[0] ?? 'Nivel 1') + ": " + _toDisplayString(item.sub.nombrePrimerNivel), 9, _hoisted_16),
                                    _cache[27] || (_cache[27] = _createElementVNode("td", { class: "cell" }, null, -1)),
                                    _cache[28] || (_cache[28] = _createElementVNode("td", { class: "cell" }, null, -1)),
                                    _cache[29] || (_cache[29] = _createElementVNode("td", { class: "cell" }, null, -1)),
                                    _createElementVNode("td", _hoisted_17, _toDisplayString(formatNum(item.sub.calPonderada ?? 0)), 1),
                                    _cache[30] || (_cache[30] = _createElementVNode("td", { class: "cell" }, null, -1)),
                                    _cache[31] || (_cache[31] = _createElementVNode("td", { class: "cell" }, null, -1))
                                  ]))
                                : (_openBlock(), _createElementBlock("tr", {
                                    key: 1,
                                    class: _normalizeClass(claseFilaTipo(item.fila.tipo))
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nombresNivelesComponentes.value, (_, nivel) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: `comp-${idx}-${nivel}`
                                      }, [
                                        (item.spansNivel[nivel]?.render)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("td", {
                                                class: "cell col-comp-num",
                                                rowspan: item.spansNivel[nivel].span
                                              }, _toDisplayString(item.fila.rutaNumeros[nivel] ?? ''), 9, _hoisted_18),
                                              _createElementVNode("td", {
                                                class: "cell col-comp",
                                                rowspan: item.spansNivel[nivel].span
                                              }, _toDisplayString(item.fila.rutaComponentes[nivel] ?? ''), 9, _hoisted_19),
                                              _createElementVNode("td", {
                                                class: "cell col-comp-peso",
                                                rowspan: item.spansNivel[nivel].span
                                              }, _toDisplayString(item.fila.rutaPesos[nivel] ?? ''), 9, _hoisted_20)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128)),
                                    _createElementVNode("td", _hoisted_21, _toDisplayString(item.fila.nombreIndicador), 1),
                                    _createElementVNode("td", _hoisted_22, _toDisplayString(item.fila.pesoIndicador), 1),
                                    _createElementVNode("td", _hoisted_23, _toDisplayString(item.fila.nombreInstrumento), 1),
                                    _createElementVNode("td", _hoisted_24, _toDisplayString(item.fila.tipoInstrumento), 1),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell col-k", claseCeldaFuente(item.fila, 'documental')])
                                    }, [
                                      (item.fila.calDocumental != null && esTipoFuente(item.fila, 'documental'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(formatNum(item.fila.calDocumental)), 1))
                                        : _createCommentVNode("", true)
                                    ], 2),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell col-l", claseCeldaFuente(item.fila, 'cuantitativa')])
                                    }, [
                                      (item.fila.calCuantitativa != null && esTipoFuente(item.fila, 'cuantitativa'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(formatNum(item.fila.calCuantitativa)), 1))
                                        : _createCommentVNode("", true)
                                    ], 2),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell col-m", claseCeldaFuente(item.fila, 'opinion')])
                                    }, [
                                      (item.fila.calOpinion != null && esTipoFuente(item.fila, 'opinion'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(formatNum(item.fila.calOpinion)), 1))
                                        : _createCommentVNode("", true)
                                    ], 2),
                                    _createElementVNode("td", _hoisted_28, [
                                      (item.fila.calPonderada != null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(formatNum(item.fila.calPonderada)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_30, _toDisplayString(item.fila.grado ?? '—'), 1),
                                    _createElementVNode("td", _hoisted_31, [
                                      (item.fila.clasificacion !== 'no_aplica')
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: _normalizeClass(["badge-clas", 'clas-' + item.fila.clasificacion])
                                          }, _toDisplayString(clasifLabel(item.fila.clasificacion)), 3))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_32, "—"))
                                    ])
                                  ], 2))
                            ], 64))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_33, [
                            _createElementVNode("td", {
                              class: "cell total-label",
                              colspan: nombresNivelesComponentes.value.length * 3 + 4
                            }, "CALIFICACIÓN GENERAL", 8, _hoisted_34),
                            _createElementVNode("td", _hoisted_35, _toDisplayString(formatNum(totalesGenerales.value.documental)), 1),
                            _createElementVNode("td", _hoisted_36, _toDisplayString(formatNum(totalesGenerales.value.cuantitativa)), 1),
                            _createElementVNode("td", _hoisted_37, _toDisplayString(formatNum(totalesGenerales.value.opinion)), 1),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(formatNum(totalesGenerales.value.ponderada)), 1),
                            _cache[32] || (_cache[32] = _createElementVNode("td", { class: "cell" }, null, -1)),
                            _cache[33] || (_cache[33] = _createElementVNode("td", { class: "cell" }, null, -1))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("table", _hoisted_39, [
                        _createElementVNode("colgroup", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nombresNivelesComponentes.value, (_, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `col-group-h-${index}`
                            }, [
                              _cache[34] || (_cache[34] = _createElementVNode("col", { class: "col-comp-num-col" }, null, -1)),
                              _cache[35] || (_cache[35] = _createElementVNode("col", { class: "col-comp-col" }, null, -1)),
                              _cache[36] || (_cache[36] = _createElementVNode("col", { class: "col-comp-peso-col" }, null, -1))
                            ], 64))
                          }), 128)),
                          _cache[37] || (_cache[37] = _createElementVNode("col", { class: "col-n-col" }, null, -1)),
                          _cache[38] || (_cache[38] = _createElementVNode("col", { class: "col-o-col" }, null, -1)),
                          _cache[39] || (_cache[39] = _createElementVNode("col", { class: "col-p-col" }, null, -1))
                        ]),
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nombresNivelesComponentes.value, (nombreNivel, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: `nivel-header-h-${index}`
                              }, [
                                _cache[40] || (_cache[40] = _createElementVNode("th", { class: "cell col-comp-num" }, "N°", -1)),
                                _createElementVNode("th", _hoisted_41, _toDisplayString(nombreNivel), 1),
                                _cache[41] || (_cache[41] = _createElementVNode("th", { class: "cell col-comp-peso" }, "PESO", -1))
                              ], 64))
                            }), 128)),
                            _cache[42] || (_cache[42] = _createElementVNode("th", { class: "cell col-n" }, "CALIFICACIÓN", -1)),
                            _cache[43] || (_cache[43] = _createElementVNode("th", { class: "cell col-o" }, [
                              _createTextVNode("NIVEL DE"),
                              _createElementVNode("br"),
                              _createTextVNode("CUMPLIMIENTO")
                            ], -1)),
                            _cache[44] || (_cache[44] = _createElementVNode("th", { class: "cell col-p" }, "FORTALEZA", -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasRenderizadas.value, (item, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `row-h-${idx}`
                            }, [
                              (item.tipo === 'subtotal')
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                                    _createElementVNode("td", {
                                      class: "cell subtotal-label",
                                      colspan: nombresNivelesComponentes.value.length * 3
                                    }, " Subtotal " + _toDisplayString(nombresNivelesComponentes.value[0] ?? 'Factor') + ": " + _toDisplayString(item.sub.nombrePrimerNivel), 9, _hoisted_43),
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(formatNum(item.sub.calPonderada ?? 0)), 1),
                                    _cache[45] || (_cache[45] = _createElementVNode("td", { class: "cell" }, null, -1)),
                                    _cache[46] || (_cache[46] = _createElementVNode("td", { class: "cell" }, null, -1))
                                  ]))
                                : (_openBlock(), _createElementBlock("tr", {
                                    key: 1,
                                    class: _normalizeClass(claseFilaTipo(item.fila.tipo))
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nombresNivelesComponentes.value, (_, nivel) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: `comp-h-${idx}-${nivel}`
                                      }, [
                                        (item.spansNivel[nivel]?.render)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("td", {
                                                class: "cell col-comp-num",
                                                rowspan: item.spansNivel[nivel].span
                                              }, _toDisplayString(item.fila.rutaNumeros[nivel] ?? ''), 9, _hoisted_45),
                                              _createElementVNode("td", {
                                                class: "cell col-comp",
                                                rowspan: item.spansNivel[nivel].span
                                              }, _toDisplayString(item.fila.rutaComponentes[nivel] ?? ''), 9, _hoisted_46),
                                              _createElementVNode("td", {
                                                class: "cell col-comp-peso",
                                                rowspan: item.spansNivel[nivel].span
                                              }, _toDisplayString(item.fila.rutaPesos[nivel] ?? ''), 9, _hoisted_47)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128)),
                                    _createElementVNode("td", _hoisted_48, [
                                      (item.fila.calPonderada != null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(formatNum(item.fila.calPonderada)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_50, _toDisplayString(item.fila.grado ?? '—'), 1),
                                    _createElementVNode("td", _hoisted_51, [
                                      (item.fila.clasificacion !== 'no_aplica')
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: _normalizeClass(["badge-clas", 'clas-' + item.fila.clasificacion])
                                          }, _toDisplayString(clasifLabel(item.fila.clasificacion)), 3))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_52, "—"))
                                    ])
                                  ], 2))
                            ], 64))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_53, [
                            _createElementVNode("td", {
                              class: "cell total-label",
                              colspan: nombresNivelesComponentes.value.length * 3
                            }, "CALIFICACIÓN GENERAL", 8, _hoisted_54),
                            _createElementVNode("td", _hoisted_55, _toDisplayString(formatNum(totalesGenerales.value.ponderada)), 1),
                            _cache[47] || (_cache[47] = _createElementVNode("td", { class: "cell" }, null, -1)),
                            _cache[48] || (_cache[48] = _createElementVNode("td", { class: "cell" }, null, -1))
                          ])
                        ])
                      ]))
                ])
              ], 544))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})